export default "__VITE_ASSET__C30RPwRO__"